export enum EEnvironmentId {
	dev1 = "dev1",
	prod = "prod",
	test = "test",
	ci = "ci"
}